<template>
    <nav>
        <section class="d-none d-md-block">
            <v-bottom-navigation horizontal
                                 class="navigation-block"
                                 value.sync="activeLinkName"
                                 color="#0156AD"
                                 background-color="white" >
                <div class="main-toolbar">
                    <div class="logo-block">
                        <img class="m-auto" src="@/static/Artboard_1.png" width="60px" height="30px">
                    </div>
                    <div class="menu-block">
                        <div class="menu-block_items">
                            <template v-for="(item, index) in menuItems">

                                <!-- Если у нас сабменю (есть дети) не пустое добавляем  наш пункт меню в общее меню-->
                                <template v-if="item.childrens!=null && item.childrens.length>0">

                                    <v-btn text @click="redirectTo(item.childrens[0].name)">
                                        <span class="menu-item">{{ item.title }}</span>
                                        <iconItem :iconName="item.icon"></iconItem>
                                    </v-btn>

                                    <v-expand-transition>
                                        <div v-show="item.childrens.findIndex(x=>x.name==activeLinkName)!=-1"
                                             class="submenu-block">
                                            <div class="submenu-items">
                                                <!-- добавляем все элементы субменю -->
                                                <template  v-for="(child, i) in item.childrens">
                                                    <v-btn :value="child.name" @click="redirectTo(child.name)"
                                                           style="width: 100px; height: 100%"
                                                           :input-value="child.name==activeLinkName">
                                                        <span class="menu-item">{{ child.title }}</span>
                                                    </v-btn>
                                                </template>
                                            </div>
                                        </div>
                                    </v-expand-transition>

                                </template>

                                <v-btn v-else
                                       @click="redirectTo(item.name)"
                                       :value="item.name"
                                       :input-value="item.name==activeLinkName">
                                    <span class="menu-item">{{ item.title }}</span>
                                    <iconItem :iconName="item.icon"></iconItem>
                                </v-btn>
                            </template>
                        </div>

                        <div class="menu-block_user-info">
                            <v-btn icon id="bell">
                                <v-icon>
                                    mdi-bell
                                </v-icon>
                            </v-btn>

                            <v-menu
                                    offset-y
                                    bottom
                                    left
                                    :nudge-width="140"
                                    v-model="showUserActions"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                            icon
                                            v-on="on"
                                    >
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>

                                <v-list dense>
                                    <v-list-item @click="showAvatarModal">
                                        <v-list-item-icon style="margin-right: 18px">
                                            <v-icon size="22" color="#C4C4C4">mdi-account-box-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title class="sub-menu-actions">Сменить аватар</v-list-item-title>
                                    </v-list-item>

                                    <v-list-item @click="redirectTo('PersonalArea',111)">
                                        <v-list-item-icon style="margin-right: 18px">
                                            <v-icon size="20" color="#C4C4C4">mdi-asterisk</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title class="sub-menu-actions">Сменить пароль</v-list-item-title>
                                    </v-list-item>


                                    <v-list-item class="mt-2" @click="logOut">
                                        <v-list-item-icon style="margin-right: 18px">
                                            <v-icon size="22" color="#C4C4C4">mdi-logout-variant</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title class="sub-menu-actions">Выйти из профиля</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>

                            <v-avatar class="m-auto"
                                      size="40px"
                                      color="accent"
                            >
                                <img
                                        v-if="userAvatar!=null"
                                        :src="$root.docsUrl+userAvatar"
                                >

                                <img v-else src="../assets/noavatar.png" height="40" width="40"/>
                            </v-avatar>
                            <avatarModal :show="avatarModal" @close="closeAvatarModal"></avatarModal>
                        </div>
                    </div>
                </div>
            </v-bottom-navigation>
        </section>

        <!--        Mobile navigation       -->
        <section class="d-lg-none d-xl-none">
            <v-app-bar color="white">
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

                <v-spacer></v-spacer>

                <div class="">
                    <img class="m-auto mobile-logo" src="@/static/Artboard_1.png" width="60px" height="30px">
                </div>
                <v-spacer></v-spacer>

            </v-app-bar>

            <v-navigation-drawer
                    v-model="drawer"
                    absolute
                    left
            >
                <v-list-item>
                    <v-avatar class="m-auto"
                              size="40px"
                              color="accent"
                    >
                        <img
                                v-if="userAvatar!=null"
                                :src="$root.docsUrl+userAvatar"
                        >

                        <img v-else src="../assets/noavatar.png" height="40" width="40"/>
                    </v-avatar>

                </v-list-item>

                <v-divider></v-divider>

                <template v-for="(item, index) in menuItems">

                    <!-- Если у нас сабменю (есть дети) не пустое добавляем  наш пункт меню в общее меню-->
                    <v-list v-if="item.childrens!=null && item.childrens.length>0">
                        <v-list-item text @click.stop="redirectTo(item.childrens[0].name)">
                            <v-list-item-icon style="margin-right: 18px">
                                <iconItem :iconName="item.icon"></iconItem>
                            </v-list-item-icon>
                            <v-list-item-title class="">{{ item.title }}</v-list-item-title>
                        </v-list-item>

                        <v-expand-transition>
                            <div v-show="item.childrens.findIndex(x=>x.name==activeLinkName)!=-1"
                                 class="">
                                <div class="">
                                    <!-- добавляем все элементы субменю -->
                                    <template  v-for="(child, i) in item.childrens">
                                        <v-list-item :value="child.name" @click="redirectTo(child.name)"
                                                     style="margin-right: 18px;  height: 100%"
                                                     :input-value="child.name==activeLinkName">
                                            <v-list-item-title class=""> - {{ child.title }}</v-list-item-title>
                                        </v-list-item>
                                    </template>
                                </div>
                            </div>
                        </v-expand-transition>
                    </v-list>

                    <v-list-item :value="item.name" v-else @click="redirectTo(item.name)"
                                 :input-value="item.name==activeLinkName">
                        <v-list-item-icon style="margin-right: 18px">
                            <iconItem :iconName="item.icon"></iconItem>
                        </v-list-item-icon>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </template>

                <v-divider></v-divider>


                <v-list dense>
                    <!--      Нижняя часть меню                      -->
                    <v-list-item @click="showAvatarModal">
                        <v-list-item-icon style="margin-right: 18px">
                            <v-icon size="22" color="#C4C4C4">mdi-account-box-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="sub-menu-actions">Сменить аватар</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="redirectTo('PersonalArea',111)">
                        <v-list-item-icon style="margin-right: 18px">
                            <v-icon size="20" color="#C4C4C4">mdi-asterisk</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="sub-menu-actions">Сменить пароль</v-list-item-title>
                    </v-list-item>

                    <v-list-item class="mt-2" @click="logOut">
                        <v-list-item-icon style="margin-right: 18px">
                            <v-icon size="22" color="#C4C4C4">mdi-logout-variant</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="sub-menu-actions">Выйти из профиля</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
        </section>
        <!--        Mobile navigation       -->
    </nav>

</template>
<script>
  import Mgr from '../services/SecureService'
  import { mapGetters } from 'vuex';
  import iconItem from'./icons.vue'
  const avatarModal = ()=> import('../components/ChangeAvatarModal.vue')
export default {
    props:["activeLinkName"],
    components:{iconItem, avatarModal},
    data() {
        return {
            showUserActions:false,
            drawer:false,
            mgr: new Mgr(),
            result: '',
            avatarModal:false,
            items: [
                {
                    icon: 'mdi-dots-vertical',
                    href: '#',
                    title: 'Настройки',
                    click: () => {
                        const vm = this;
                        vm.$router.push({name: 'PersonalArea'});
                    }
                },
                {
                    icon: 'exit_to_app',
                    href: '#',
                    title: 'Выйти',
                    click: () => {
                        const vm = this;
                        this.logOut();
                    }
                }
            ],

        }
    },
    created() {
        const vm=this;
        this.$store.dispatch("userData/getMenuItems").then(()=>{
            if(this.$route.name=="Main") {
                let items = vm.$store.state.userData.menuItems.sort(x => x.ordering)
                let firstMenuItem = items[0]
                vm.$router.push({name: firstMenuItem.name});
            }
        })

    },
    methods: {
        showAvatarModal(){
            this.avatarModal=true
        },

        closeAvatarModal(isSave){
            this.avatarModal=false
            if(isSave==true){
                this.$store.dispatch("userData/loadWebUserData", this.user.profile.sub)
            }
        },

        toggleNavigationBar() {
            const vm = this;
            vm.$emit('toggleNavigationBar');
        },

        logOut() {
            this.mgr.signOut();
        },

        redirectTo(path, code) {
            const vm = this;
            //удаляем уведомление из списка
            this.$store.dispatch("Notifications/removeNotification", code);
            //переходим на нужную страницу
            vm.$router.push({name: path});
        }

    },
    computed: {
        ...mapGetters({
            user: "userData/getUser",
            webUserInfo: "userData/getWebUser",
            menuItemsForRole: "userData/getMenuItems",
        }),

        activeName:{
            get: function(){
                return this.activeLinkName
            },
            set:function(value){

            }
        },
        notifications() {
            return this.$store.state.Notifications.items;
        },

        userAvatar() {
            var user = this.webUserInfo;
            if (user != null) {
                return user.webUserLogo
            }
            else return null
        },

        userName() {
            if (this.user != null) {
                return this.user.profile.name.split(/\s/);
            }
            else return "Admin admin";
        },
        menuItems() {
            /*if (this.user != null) {
                return this.menuItemsForRole(this.user.profile.role);
            }*/
            let items=this.$store.state.userData.menuItems
            return items.sort(x=>x.ordering)
        },
    },
    watch:{
        '$route' (to, from) {
            this.activeLinkName=to.name;


        }
    }
};
</script>

<style>

    .sub-menu-actions{
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #000000;
    }

    .navigation-block{
        width: 100%;
        position: fixed; top:0; z-index:1000; height: 64px;
        box-shadow: 0 0 0px rgba(0,0,0,0) !important;
        -webkit-box-shadow:0 0 0px rgba(0,0,0,0) !important;

    }
    .main-toolbar{
        position: relative;
        width: 100%;
        margin: 0 auto;
        padding-top: 5px;
        border-bottom: 1px solid rgb(211, 218, 225);
    }

.submenu-block{
    position:fixed;
    left: 0;
    width: 100%;
    top:56px;
    margin: 0 auto;
    height: 48px;
    border-bottom: 1px solid #D3DAE1;
    background-color: white;
}

    .submenu-items{
        width: 80%;
        margin: 0px auto;
        height: 100%;

    }


</style>

<style scoped>
    .logo-block{
        width: 10%;
        text-align: center;
        margin: 10px auto;
        position: absolute;
    }
    .logo-block>img{
        top: 10px;
    }

    .menu-block_user-info{
        margin-right:5px;
        display: flex;
    }

    .menu-block{
        margin: 0px auto;
        width: 80%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .menu-block_items{
        height: 100%;
    }
    .mobile-logo{
        margin-left: -24px !important;
    }
    @media (max-width: 1480px) {

    }
    @media (max-width:1195px){
        .v-item-group.v-bottom-navigation .v-btn{
            min-width: 0 !important;
        }
    }
</style>